// Utilitários do módulo Fee Fixo.
import { toMoney, toPercent } from '@utils/Format'
import { CENARIOS_CAPTACAO } from '@modules/fee-fixo/constants/Text'

// Valor numérico seguro de obj[key] (0 quando ausente).
export const numOr0 = (obj, key) => (obj && obj[key] ? obj[key] : 0)

// Tom por sinal do valor (pos/neg) — usado para a cor verde/vermelho.
export const toneBySign = (value) => (value >= 0 ? 'pos' : 'neg')

// 1 ano de juros compostos (rent [+ alfa] − custo do ano) + aporte anual.
const compoundYear = (p, rent, custoBps, aporte) => p * (1 + rent - custoBps / 10000) + aporte

// Série anual de patrimônio de UM regime — auc composto ano a ano contra
// sua própria série de custo (bps), com o mesmo aporte a cada ano.
const projectPatrimonySeries = (auc, rent, custoSerie, aporte, anos) => {
  const serie = [auc]
  let p = auc
  for (let y = 1; y < anos; y++) {
    p = compoundYear(p, rent, custoSerie[y] || 0, aporte)
    serie.push(p)
  }
  return serie
}

// Recompõe as séries anuais de patrimônio (comis / fee / cons) ano a ano.
// `aporte` soma o mesmo valor pros 3 regimes a cada ano (dinheiro novo do
// cliente, não depende de qual assessor administra) — mesma lógica de
// patrOf (fee-lab-engine.js) e da engine V0 do CTO (projetar()).
export const computePatrimony = (years, series, auc, rent, alfa, aporte) => {
  const ap = Number(aporte) || 0
  return {
    comis: projectPatrimonySeries(auc, rent, series.comis, ap, years.length),
    fee: projectPatrimonySeries(auc, rent + alfa, series.fee, ap, years.length),
    cons: projectPatrimonySeries(auc, rent + alfa, series.cons, ap, years.length),
  }
}

// Nome amigável do cenário de captação.
const humanizeCenario = (cenario) => {
  const item = CENARIOS_CAPTACAO.find((c) => c.value === cenario)
  return item ? item.text : cenario || 'Base'
}

// Monta as linhas de "PARÂMETROS" da descrição da tarefa a partir dos inputs
// da análise da simulação.
export const buildDescricaoParametros = (inputs) => {
  const lines = ['PARÂMETROS:']
  lines.push(`• Patrimônio total: ${toMoney(inputs.patrimonio_total || 0)}`)
  if (inputs.patrimonio_fora) {
    lines.push(`• Patrimônio fora: ${toMoney(inputs.patrimonio_fora)}`)
  }
  lines.push(
    `• ROA atual: ${toPercent((inputs.roa || 0) * 100)}`,
    `• Fee proposto: ${toPercent((inputs.fee || 0) * 100)}`,
    `• Comissão: ${toPercent((inputs.comissao || 0) * 100)}`,
    `• Cenário de captação: ${humanizeCenario(inputs.cenario_captacao)}`
  )
  return lines
}
